export default {
  changeLanguageTips: 'Switching language succeeded',
  unknownError: 'Unknown Error, please contact the administrator!',
}
